export const getUniqueId = () => {
  return +new Date() + "" + Math.floor(Math.random() * 100000 + 1);
};
